import { useCallback } from 'react';
import useAnalytics from '../../../analytics/useAnalytics';
import { REVIEW_SUGGESTIONS_EVENT_NAMES } from './event-name';
import type { AcceptOrRejectMLSuggestionPayloadT } from './types';
const useAnalyticsForReviewSuggestions = () => {
  const {
    sendEvent
  } = useAnalytics();
  const sendEventForAcceptMLSuggestion = useCallback((payload: AcceptOrRejectMLSuggestionPayloadT) => {
    sendEvent({
      action: REVIEW_SUGGESTIONS_EVENT_NAMES.ACCEPT_ML_SUGGESTION,
      payload
    });
  }, [sendEvent]);
  const sendEventForRejectMLSuggestion = useCallback((payload: AcceptOrRejectMLSuggestionPayloadT) => {
    sendEvent({
      action: REVIEW_SUGGESTIONS_EVENT_NAMES.REJECT_ML_SUGGESTION,
      payload
    });
  }, [sendEvent]);
  return {
    sendEventForAcceptMLSuggestion,
    sendEventForRejectMLSuggestion
  };
};
export default useAnalyticsForReviewSuggestions;